import Vue from 'vue';
import VueRouter from 'vue-router';
import Map from '@/views/Map.vue';
import NotFound from '@/views/NotFound.vue';
import Axios from 'axios';

Vue.use(VueRouter);
const config =  require('@/config.json');
Vue.prototype.$config = config;
document.title = config["platform_name"];
const routes = [
    { path: '/', redirect: { name: 'countries' }},
    {
        path: '/countries',
        name: 'countries',
        component: () => import('@/views/Countries.vue'),
    }
];

config.countries.map(code => {
    routes.push({
        path: `/${code}`,
        name: code,
        component: Map,
        props: { countryCode: code},
    });
});

routes.push({
    path: '*',
    component: NotFound,
});

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

const axiosConfig = {
    baseURL : "/api"
};

Vue.config.productionTip = false;

Vue.prototype.$axios = Axios.create(axiosConfig);

export default router
